import React, { useState, useEffect } from "react";
import "./Donation.css"; // Add styles here or in a separate file
import Footer from "../Footer";

const Donation = () => {
  const [progress, setProgress] = useState(0);
  const [donated, setDonated] = useState(false);

  // Simulate donation progress increment
  useEffect(() => {
    if (progress < 100) {
      const interval = setInterval(() => {
        setProgress((prev) => (prev < 100 ? prev + 1 : prev));
      }, 100); // Adjust speed as needed
      return () => clearInterval(interval);
    }
  }, [progress]);

  const handleDonate = () => {
    setDonated(true);
    setTimeout(() => {
      setProgress(100);
    }, 500);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Full viewport height
      }}
    >
      <div className="donation-container" style={{ flex: 1 }}>
        <h2 style ={{color:"#02353c"}}>Support the Legacy of TISS – Transform Lives Today</h2>
        
        <div className="progress-bar">
          <div
            className="progress"
            style={{
              width: `${progress}%`,
              backgroundColor: progress === 100 ? "#449342" : "#449342",
            }}
          ></div>
        </div>
        <p style={{fontSize:"1.2rem"}}>
          {progress === 100
            ? "Help us to reach our goal"
            : `Donation Progress: ${progress}%`}
        </p>
        <button
          className={`donate-button ${donated ? "donated" : ""}`}
          onClick={handleDonate}
          disabled={progress === 100}
        >
          {donated ? "" : "Donate Now"}
        </button>

        {/* Bank Details */}
        <div className="bank-details" style={{ marginTop: "20px", textAlign: "left" }}>
          <h3>Bank Details for Direct Donation:</h3>
          <p><strong>Bank Name:</strong> ICICI Bank</p>
          <p><strong>Account Number:</strong> 109801000823</p>
          <p><strong>Account Holder Name:</strong> TISS Alums Association</p>
          <p><strong>IFSC:</strong> ICIC0001098</p>
          <p style={{textAlign:"center", fontSize:"1.2rem", marginTop:"40px"}}>Thank You For Your Support !!!!</p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Donation;
